import React from "react";

function RaiseHand({questionCount, onClick}) {
    return (
        <button className="absolute z-30" onClick={onClick}>
          <span role="img" aria-label="raising hand"  className="text-5xl">✋</span>
          {questionCount > 0 && (
          <div
            className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex justify-center items-center text-sm"
          >
            {questionCount}
          </div>
        )}
        </button>

    );
}

export default RaiseHand;